import { useState } from "react";
import { Carousel } from "react-bootstrap";
import { useIntl } from "react-intl";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../utils/CommonHelper";
import { InboxList } from "./inboxList";

export const DashboardList = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [isHomeIndex, setIsHomeIndex] = useState(
    localStorage.getItem("isHomeIndex") === "true"
  );
  const dashboardState = useSelector(
    ({ dashboard }) => dashboard,
    shallowEqual
  );

  const awardStyle = { width: "30%" };
  const slideStyle = { width: "30%", height: "50px" };
  const bottomStyle = { width: "15%" };

  return (
    <div className="pt-2">
      <div className="px-2">
        <div className="fw-semibold text-white">
          {intl.formatMessage({ id: "ranking" })}
        </div>
        <div className="d-flex flex-wrap text-white pb-1 m-1 rounded border">
          {dashboardState.dashboard?.mbDashboardRankists?.map(
            (mbDashboardRank) => (
              <div
                key={mbDashboardRank.username}
                className="d-flex col-6 justify-content-between align-items-center px-1"
                style={{ fontSize: "13px" }}
              >
                <div style={{ color: "#90D5FF" }}>
                  {mbDashboardRank.username}
                </div>
                <div>{mbDashboardRank.withdrawamount}</div>
              </div>
            )
          )}
        </div>
        <div className="fw-semibold text-white my-2">
          {intl.formatMessage({ id: "message" })}
        </div>
        <div>
          <InboxList />
        </div>
        <div className="fw-semibold text-white my-2">
          {intl.formatMessage({ id: "ourPartners" })}
        </div>
        <div className="card rounded shadow bg-dark">
          <div className="card-body p-2 pb-2">
            <div>
              <Carousel
                indicators={false}
                controls={false}
                data-bs-theme="dark"
                interval={3000}
                pause={false}
                className="w-100"
              >
                <Carousel.Item className="w-100">
                  <div className="d-flex justify-content-between position-relative">
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/allbet.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/dreamgaming.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/evo.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item className="w-100">
                  <div className="d-flex justify-content-between position-relative">
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/ibc.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/joker.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/kiss918.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item className="w-100">
                  <div className="d-flex justify-content-between position-relative">
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/mega.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/microgaming.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/playtech.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="d-flex justify-content-between position-relative">
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/pragmaticplay.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/worldentertain.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                    <div
                      style={slideStyle}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "image/memberDash/gameWebp/xe88.webp"
                        )}
                        className="w-100"
                      />
                    </div>
                  </div>
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
        </div>
        <div className="card rounded shadow bg-dark my-2">
          <div className="card-body p-2 pb-2">
            <div className="text-white mb-2" style={{ fontSize: "11px" }}>
              {intl.formatMessage({ id: "awardNomination" })}
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <img
                alt=""
                src={toAbsoluteUrl("image/memberDash/award/award2.webp")}
                style={awardStyle}
              />
              <img
                alt=""
                src={toAbsoluteUrl("image/memberDash/award/award3.webp")}
                style={awardStyle}
              />
              <img
                alt=""
                src={toAbsoluteUrl("image/memberDash/award/award4.webp")}
                style={awardStyle}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-dark p-2 mb-2">
        <div
          className="text-start text-white mb-2"
          style={{ fontSize: "11px" }}
        >
          {intl.formatMessage({ id: "paymentMethods" })}
        </div>
        <div className="d-flex flex-wrap gap-3">
          <div className="d-flex align-items-center justify-content-center col-1">
            <img
              alt=""
              src={toAbsoluteUrl(
                "image/memberDash/bottomSide/paymentMethods/fpx.webp"
              )}
              className="w-100"
            />
          </div>
          <div className="d-flex align-items-center justify-content-center col-1">
            <img
              alt=""
              src={toAbsoluteUrl(
                "image/memberDash/bottomSide/paymentMethods/TouchNGo.webp"
              )}
              className="w-100"
            />
          </div>
          <div className="d-flex align-items-center justify-content-center col-1">
            <img
              alt=""
              src={toAbsoluteUrl(
                "image/memberDash/bottomSide/paymentMethods/master_card.webp"
              )}
              className="w-100"
            />
          </div>
          <div className="d-flex align-items-center justify-content-center col-1">
            <img
              alt=""
              src={toAbsoluteUrl(
                "image/memberDash/bottomSide/paymentMethods/visa.webp"
              )}
              className="w-100"
            />
          </div>
        </div>
        <div className="d-flex flex-wrap">
          <div
            className="text-start text-white my-2 col-6"
            style={{ fontSize: "11px" }}
          >
            {intl.formatMessage({ id: "responsibleGaming" })}
          </div>
          <div
            className="text-start text-white my-2 col-6"
            style={{ fontSize: "11px" }}
          >
            {intl.formatMessage({ id: "security" })}
          </div>
          <div className="col-6 d-flex gap-3">
            <div
              className="d-flex align-items-center justify-content-center"
              style={bottomStyle}
            >
              <img
                alt=""
                src={toAbsoluteUrl(
                  "image/memberDash/bottomSide/responsibleGaming/18+.webp"
                )}
                className="w-100"
              />
            </div>
            <div
              className="d-flex align-items-center justify-content-center"
              style={bottomStyle}
            >
              <img
                alt=""
                src={toAbsoluteUrl(
                  "image/memberDash/bottomSide/responsibleGaming/begambleaware.webp"
                )}
                className="w-100"
              />
            </div>
            <div
              className="d-flex align-items-center justify-content-center"
              style={bottomStyle}
            >
              <img
                alt=""
                src={toAbsoluteUrl(
                  "image/memberDash/bottomSide/responsibleGaming/gamcare.webp"
                )}
                className="w-100"
              />
            </div>
          </div>
          <div className="col-6 d-flex gap-3">
            <div className="d-flex align-items-center justify-content-center w-25">
              <img
                alt=""
                src={toAbsoluteUrl(
                  "image/memberDash/bottomSide/security/iovation.webp"
                )}
                className="w-100"
              />
            </div>
            <div className="d-flex align-items-center justify-content-center w-25">
              <img
                alt=""
                src={toAbsoluteUrl(
                  "image/memberDash/bottomSide/security/threatmetrix.webp"
                )}
                className="w-100"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="px-2 text-white mb-4">
        <div className="form-check text-font2">
          <input
            className="form-check-input"
            id="isHomeIndex"
            type="checkbox"
            checked={isHomeIndex}
            onChange={(e) => {
              setIsHomeIndex(e.target.checked);
              localStorage.setItem("isHomeIndex", e.target.checked);
            }}
          />
          <label className="form-check-label" htmlFor="isHomeIndex">
            {intl.formatMessage({ id: "setDefaultHomePage" })}
          </label>
        </div>
      </div>
      <div style={{ height: "38px" }} />
      {/* <div
        className="position-absolute start-50 translate-middle"
        style={{ bottom: "50px" }}
      >
        <button
          className="btn btn-warning rounded-pill fw-bold px-5"
          onClick={() => navigate("/home")}
        >
          {intl.formatMessage({ id: "playGame" })}
        </button>
      </div> */}
    </div>
  );
};
